<template>
  <div>
    <v-dialog v-model="visible" max-width="600px">
      <v-card>
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>投保须知及声明</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-list class="notice-list">
          <v-list-tile>
            <v-list-tile-title>
              <a
                class="notice-list-link"
                target="_blank"
                href="https://qihuibao.oss-cn-beijing.aliyuncs.com/ptk/1001/%E8%AF%9A%E6%B3%B0%E5%9B%A2%E4%BD%93%E4%BA%BA%E8%BA%AB%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9-%E6%8A%95%E4%BF%9D%E9%A1%BB%E7%9F%A5.pdf"
              >《投保须知》</a>
            </v-list-tile-title>
          </v-list-tile>
          <v-divider class="ml-4"></v-divider>
          <v-list-tile>
            <v-list-tile-title>
              <a class="notice-list-link" @click="agreement">《保险经纪委托协议》</a>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>
    <Agreement v-model="agreementVisible"></Agreement>
  </div>
</template>

<script>
import Agreement from "@/components/Product/Agreement";
export default {
  components: {
    Agreement
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      agreementVisible: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  methods: {
    agreement() {
      this.visible = false;
      this.agreementVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-list {
  .notice-list-link {
    color: inherit;
    text-decoration: none;
  }
}
</style>

